module.exports = __webpack_public_path__ + "img/proceso-formacion-hidrocarburos.21136959.png";